import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import Header from '../components/header'
import Footer from '../components/footer'

import {Grid, Row, Col} from 'react-flexbox-grid';

import {MuiThemeProvider} from '@material-ui/core/styles';
import ShareMealsMUITheme from '../components/theme'
import favicon from './favicon.png';

import '../scss/style.scss'


export default class TemplateWrapper extends React.Component{
    render(){
	// TODO fix og:image
	let ogimage_url = '/assets/img/og_image.png';
	let site_url = this.props.data.site.siteMetadata.url;
	if(typeof(window) !== 'undefined'){
	    // development mode
	    // do nothing
	}else{
	    // production mode
	    ogimage_url = site_url + ogimage_url;
	}
	return(
	    <div>
		<Helmet
		    meta={[
			{property: 'og:title',
			 content: this.props.data.site.siteMetadata.title},
			{property: 'og:description',
			 content: 'Share Meals is ending college hunger through technology, activism, and advocacy'},
			{property: 'og:type',
			 content: 'website'},
			{property: 'og:image',
			 content: ogimage_url},
			{property: 'og:url',
			 content: site_url + this.props.location.pathname}
		    ]}>
		    <title>Share Meals</title>
		    <link rel="shortcut icon" type="image/png" href={favicon} />
		</Helmet>

		<MuiThemeProvider theme={ShareMealsMUITheme}>
		    <div>
			<div style={{height: 64, backgroundColor: "#106535"}}></div>
			<Header imgs={{
			    logo: {
				white: this.props.data.logo_white
				}
			}}/>
			<div id='content'>
			    {this.props.children()}
			</div>
			<Footer imgs={{
			    logo: {
				white: this.props.data.logo_white
			    }
			}}/>
		    </div>
		</MuiThemeProvider>
	    </div>
	)
    }
}


export const query = graphql`
    query layoutQuery{
	site {
	    siteMetadata{
		title
		url
	    }
	}
	logo_white: file(relativePath:{ eq: "assets/img/logo/white-nameplate.png"}){
	    childImageSharp{
		sizes(
		    quality: 100
		){
		    ...GatsbyImageSharpSizes
		}
	    }
	}
    }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js